import script from "./CustomTabbar.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTabbar.vue?vue&type=script&setup=true&lang=js"

import "./CustomTabbar.vue?vue&type=style&index=0&id=d1b6298c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d1b6298c"]])

export default __exports__